import type { IKeypointDefinition } from '@/visualization/domain/sizing/templates/types';

export interface KeypointBarProps {
    keypoints: IKeypointDefinition[];
    onSetKeypoint: (keypointId: string) => void;
}

export function KeypointBar({ keypoints, onSetKeypoint }: KeypointBarProps) {
    return (
        <div className="w-full border-b border-border px-3 py-2">
            <div className="w-full flex flex-wrap justify-center gap-1">
                {keypoints.map((kp) => (
                    <button
                        key={kp.id}
                        className="rounded bg-primary/20 border border-primary/60 px-3 py-1 text-xs font-mono font-bold text-primary hover:text-primary-foreground hover:border-transparent hover:bg-primary/80"
                        onClick={() => onSetKeypoint(kp.id)}
                        title={kp.name}
                    >
                        {kp.shortLabel}
                    </button>
                ))}
            </div>
            <p className="mt-1 text-center text-[10px] text-muted-foreground">
                Navigate to position, then click keypoint to set
            </p>
        </div>
    );
}
